(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navratri-edition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('navratri-edition')) customElements.define('navratri-edition', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const preview = this.dataset.preview === 'true' && new URLSearchParams(location.search).get('navratri_preview') === '1';
      this.update = () => {
        const start = Date.parse(this.dataset.start), end = Date.parse(this.dataset.end), now = Date.now();
        this.hidden = !(preview || Number.isFinite(start) && end > start && now >= start && now < end);
        const remaining = Number.isFinite(end) ? Math.max(0, Math.ceil((end - now) / 1000)) : 0;
        const values = { days:Math.floor(remaining / 86400), hours:Math.floor(remaining / 3600) % 24, minutes:Math.floor(remaining / 60) % 60, seconds:remaining % 60 };
        this.querySelectorAll('[data-countdown]').forEach(node => this.rollDigits(node, String(values[node.dataset.countdown]).padStart(2, '0')));
        this.classList.toggle('is-dancing', Boolean(this.inView && !this.hidden && !document.hidden && !this.reduced.matches));
        if (this.hidden) this.stop();
      };
      this.update();
      this.clock = setInterval(this.update, 1000);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries.some(e => e.isIntersecting);
        this.update();
        if (this.inView && !this.hidden && !this.reduced.matches && !this.dandiyaTimer) this.dance();
        if (!this.inView) this.stop();
        if (this.inView && !this.hidden && !this.played && this.dataset.fireworks === 'true' && !this.reduced.matches) {
          this.played = true;
          this.burst();
        }
      }, { threshold:.25 });
      this.observer.observe(this.querySelector('section'));
      document.addEventListener('visibilitychange', () => { if(document.hidden) this.stop(); else { this.update(); if(!this.dandiyaTimer) this.dance(); } }, {signal:this.abort.signal});
      this.reduced.addEventListener('change', () => { this.update(); if(this.reduced.matches) this.stop(); }, {signal:this.abort.signal});
    }
    rollDigits(node, value) {
      node.setAttribute('aria-label', value);
      const half = (char, side) => {
        const tile = document.createElement('span');
        tile.className = `navratri-countdown__half navratri-countdown__half--${side}`;
        const text = document.createElement('span');
        text.textContent = char;
        tile.append(text);
        return tile;
      };
      if (node.children.length !== value.length) {
        node.replaceChildren(...[...value].map(char => {
          const digit = document.createElement('span');
          digit.className = 'navratri-countdown__digit';
          digit.setAttribute('aria-hidden', 'true');
          digit.dataset.value = char;
          digit.append(half(char, 'top'), half(char, 'bottom'));
          return digit;
        }));
        return;
      }
      [...node.children].forEach((digit, index) => {
        const previous = digit.dataset.value, char = value[index];
        if (previous === char) return;
        digit.dataset.value = char;
        digit.replaceChildren(half(char, 'top'), half(char, 'bottom'));
        if (this.reduced.matches || document.hidden) return;
        const top = half(previous, 'top'), bottom = half(char, 'bottom');
        top.style.zIndex = '3';
        bottom.style.zIndex = '3';
        digit.children[1].replaceWith(half(previous, 'bottom'));
        digit.append(top, bottom);
        top.animate([{transform:'rotateX(0deg)'},{transform:'rotateX(-90deg)'}], {duration:180,easing:'ease-in',fill:'forwards'}).onfinish = () => top.remove();
        bottom.animate([{transform:'rotateX(90deg)'},{transform:'rotateX(0deg)'}], {duration:220,delay:180,easing:'ease-out',fill:'both'}).onfinish = () => digit.replaceChildren(half(char, 'top'), half(char, 'bottom'));
      });
    }
    dance() {
      if (!this.inView || this.hidden || document.hidden || this.reduced.matches) return;
      const pairs = [...this.querySelectorAll('.navratri-dandiya__pair')];
      const count = 1;
      pairs.forEach((pair,index) => {
        pair.classList.remove('is-visible');
        pair.style.right = '10%';
        pair.style.top = '0px';
        pair.style.animationDelay = `${index*.55}s`;
        if (index < count) pair.classList.add('is-visible');
      });
      this.dandiyaTimer = setTimeout(() => {
        pairs.forEach(pair => pair.classList.remove('is-visible'));
        this.dandiyaTimer = setTimeout(() => { this.dandiyaTimer = null; this.dance(); }, 5500+Math.random()*4500);
      }, 4500);
    }
    burst() {
      const canvas = this.querySelector('canvas'), ctx = canvas.getContext('2d');
      if (!ctx) return;
      const w = innerWidth, h = innerHeight, ratio = Math.min(devicePixelRatio || 1, 2);
      canvas.width = w * ratio; canvas.height = h * ratio; ctx.scale(ratio,ratio);
      const colors = ['#ffd98a','#f2a45c','#f5eee0'];
      const particles = [];
      for (let b=0; b<3; b++) for(let i=0;i<42;i++) {
        const a = i/42*Math.PI*2, speed = 45+Math.random()*100;
        particles.push({x:w*(.2+b*.3),y:h*(.24+(b%2)*.16),vx:Math.cos(a)*speed,vy:Math.sin(a)*speed,color:colors[i%3],delay:b*.35});
      }
      const began = performance.now();
      const draw = now => {
        const t=(now-began)/1000; ctx.clearRect(0,0,w,h);
        if (t>2.6 || this.hidden || document.hidden || this.reduced.matches) return;
        for(const p of particles) {
          const age=t-p.delay; if(age<0 || age>1.65) continue;
          ctx.globalAlpha=Math.max(0,1-age/1.65);ctx.fillStyle=p.color;
          ctx.beginPath();ctx.arc(p.x+p.vx*age,p.y+p.vy*age+40*age*age,1.8,0,Math.PI*2);ctx.fill();
        }
        this.frame=requestAnimationFrame(draw);
      };
      this.frame=requestAnimationFrame(draw);
    }
    stop() { this.classList.remove('is-dancing'); clearTimeout(this.dandiyaTimer); this.dandiyaTimer = null; this.querySelectorAll('.navratri-dandiya__pair').forEach(pair => pair.classList.remove('is-visible')); cancelAnimationFrame(this.frame); const c=this.querySelector('canvas'); c?.getContext('2d')?.clearRect(0,0,c.width,c.height); }
    disconnectedCallback() { this.stop();clearInterval(this.clock);this.abort?.abort();this.observer?.disconnect(); }
  });

  } catch(e) { console.error(e); }
})();
})();
